import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { RestApiService } from '../common-app/service/rest-api.service';
import { DateUtil } from '../common-app/util/date-util';
import { Kvaw0900Vo } from './kvaw0900.vo';

/**
 * サーバとの通信を行う。
 * @see WebAPI仕様_KVAW0900（担当外店舗一覧取得）.xlsx
 */
@Injectable()
export class Kvaw0900Service {

  /** 検索対象 */
  private static TARGET = 'kvaw0900';

  constructor(
    private restApiService: RestApiService,
  ) { }

  /**
   * 担当外店舗一覧を取得する
   */
  searchOtherStore(
    atskCode: string,
    kouriKna: string,
    pref: string,
    city: string,
    category: string
  ): Observable<Kvaw0900Vo> {

    const query = {
      // 検索条件（Dコード）の入力値を設定
      atskCode: atskCode,
      // 検索条件（店舗名カナ）の入力値を設定
      kouriKna: kouriKna,
      // 検索条件（都道府県コード）の選択値を設定
      atskFknCd: pref,
      // 検索条件（市区町村コード）の選択値を設定
      atskSkgnCd: city,
      // 検索条件（業態コード）の選択値を設定
      kouritnKaibaCd: category,
    };

    return this.restApiService.search<Kvaw0900Vo>(Kvaw0900Service.TARGET, query);
  }
}



// WEBPACK FOOTER //
// ./src/app/service/kvaw0900.service.ts